import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewTransferDriver, updateTransferDriver } from '../../../../slices/transferDriver/thunk';
import { setRequireCloseModal } from '../../../../slices/transferDriver/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getTransferCompanyList } from '../../../../helpers/transfer/backend_helper';
import OInput from '../../../../Components/OElements/OInput';
import OSelect from '../../../../Components/OElements/OSelect';

const TransferDriverForm = ({
	dataTransferDriver,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [selectedTransferCompany, setSelectedTransferCompany] = useState(null);
	const handleTransferCompanySelected = (optionSelected) => {
		setSelectedTransferCompany(optionSelected);
	};

	const [disabledCheck, setDisabledCheck] = useState(dataTransferDriver.disable);

	const selectorTransferDriver = createSelector(
		state => state.TransferDrivers,
		transferDriver => ({
			isAdding: transferDriver.isAdding,
			isAdded: transferDriver.isAdded,
			isUpdating: transferDriver.isUpdating,
			isUpdated: transferDriver.isUpdated,
			isLoadingList: transferDriver.isLoadingList,
			requireCloseModal: transferDriver.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorTransferDriver);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			rut: dataTransferDriver.rut || '',
			name: dataTransferDriver.name || '',
			transfer_company_id: dataTransferDriver.transfer_company_id || '',
		},
		validationSchema: Yup.object({
			rut: Yup.string().required('Campo requerido'),
			name: Yup.string().required('Campo requerido'),
			transfer_company_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedTransferDriver = {
					_id: dataTransferDriver._id,
					transfer_company_id: values.transfer_company_id,
					rut: values.rut,
					name: values.name,
					disabled: (disabledCheck ? true : false)
				}
				dispatch(updateTransferDriver(updatedTransferDriver));
			} else {
				const newTransferDriver = {
					transfer_company_id: values.transfer_company_id,
					rut: values.rut,
					name: values.name,
					disabled: (disabledCheck ? true : false)
				}
				dispatch(addNewTransferDriver(newTransferDriver));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={4}>
								<OInput
									name='rut'
									label='RUT'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OInput
									name='name'
									label='Nombre'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key='transfer_company_id'
									label='Empresa de transporte'
									id='transfer_company_id'
									name='transfer_company_id'
									isRequired={true}
									value={validation.values.transfer_company_id}
									requestApi={() => getTransferCompanyList({})}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Transportista
					</button>
				</div>
			</div>
		</Form>
	);
};

export default TransferDriverForm;
